// extracted by mini-css-extract-plugin
export default {"Bold":"index__Bold__Id5Ol","Low":"index__Low__Qe4sy","Medium":"index__Medium__iRdu4","High":"index__High__RTWKo"};